import(/* webpackMode: "eager", webpackExports: ["VideoEditSidePanel"] */ "/app/apps/sb-shell/app/(darkHeader)/ai/video-edit/_components/VideoEditSidePanel.tsx");
